import React, { Component } from 'react';
import PanelView from '../model/PanelView.js';
import moment from 'moment';
import {clone, getMinistryName, getLeaderName } from '../util/Utility.js';
import { CCOButton } from '../util/Components.js';
import { Glyphicon } from 'react-bootstrap';
import EventPaymentsModal from './EventPaymentsModal.js';

export default class PaymentsPanelView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      object: clone(props.objectPass),
      showModal: false
    }
  }

  componentWillMount() {
    var object = this.state.object;
    getMinistryName(object.ministryID, this).then(name => {
      object.ministryName = name;
      this.setState({object: object});
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      var object = clone(newProps.objectPass);
      getMinistryName(object.ministryID, this).then(name => {
        object.ministryName = name;
        this.setState({object: object});
      });
    }
  }

  render() {

    var object = this.state.object;
    let numberOfRegistrations = object.rsvp ? Object.keys(object.rsvp).length : 0;

    return (
      <PanelView type="payments" contact={object.originator} {...this.props}>
        <EventPaymentsModal show={this.state.showModal} done={() => this.setState({showModal: false})} event={object} user={this.props.user} />
        <center>
          <h2 style={{margin: 0}}>{object.title}</h2>
        </center>
        <div style={{height: 7}} />
        <p>{object.description}</p>
        <p>Cost: ${object.payment.cost}</p>
        <p>Payment Deadline: {moment.unix(object.payment.deadline).format("dddd, MMMM Do YYYY")}</p>
        <p>Statement Descriptor: {object.payment.descriptor}</p>
        <p>Amount Collected: ${object.payment.cost * numberOfRegistrations} (before processing fees)</p>
        {object.originator && <p><Glyphicon glyph="user" /> Created By {getLeaderName(object.originator)}</p>}
        {object.ministryName && <p><Glyphicon glyph="heart" /> Hosted by the {object.ministryName}</p>}
        <div style={{width: 200}}>
          <CCOButton text={"Show Registered (" + numberOfRegistrations + ")"} onClick={() => this.setState({showModal: true})} type="primary" />
          <div style={{height: 10}} />
        </div>
      </PanelView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/financial/PaymentsPanelView.js
 **/